import { Component, OnInit, ViewChild } from '@angular/core';
import { DocumentoNegociableService } from '../../services/documento-negociable/documento-negociable.service';
import { CavaliService } from 'app/services/Cavali/Cavali.service';
import { MatTableDataSource, MatPaginator, MatSort } from '@angular/material';
import { RiesgoService } from '../../services/riesgo/riesgo.service';
import { Observable } from 'rxjs/Rx';
import { startWith, map, finalize } from 'rxjs/operators';
import { EmpresasService } from '../../services/empresas/empresas.service';
import { FormControl,FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { FiltrosDocumentosNegociables } from '../../models/FiltrosDocumentosNegociables';
import Swal from "sweetalert2";
import { LoginService } from 'app/services/login/login.service';
import { environment } from 'environments/environment';

declare var $: any;
@Component({
  selector: 'app-listado-doc-neg',
  templateUrl: './listado-doc-neg.component.html',
  styleUrls: ['./listado-doc-neg.component.css']
})
export class ListadoDocNegComponent implements OnInit {

  Label_Proveedor=environment.LABEL_PROVEEDOR;
  Label_Proveedores=environment.LABEL_PROVEEDORES;
  Label_Adquirente=environment.LABEL_ADQUIRENTE;
  Label_Adquirentes=environment.LABEL_ADQUIRENTES;
  ID_ROL_PRONTOPAGO = environment.ID_ROL_PP;
  flagEspecial:boolean=false;
  tipoAdjunto : number;
  DNegociable : any;
  adjuntarPDF : boolean;
  selectArchivo : boolean;
  ruc = new FormControl();
  tipoComprobante :string;
  formExtornar: FormGroup;
  estado ="R";
  id;
  adjuntoEstado : string ='T';
  filteredProveeedor: Observable<any[]>;
  proveedoresArr;
  tipoEmsion:string ;
  ruta : string;
  isRecibo:boolean = true;
  isLetra:boolean = true;
  user :any;
  idEncrip:any;
  @ViewChild(MatPaginator, {static: true}) paginator: MatPaginator;  
  @ViewChild(MatSort, {static: true}) sort: MatSort;
  // usuarios:any[]=[];
  pageSizeOptions = [15,20,30,50,100,200];
  docNegociables:any = [];
  loading:boolean;
  displayedColumns: string[] = 
            ['checked','Número','NombreComercial','RazonSocialAdquirente','Fecha_Emision',
            'Fecha_de_Pago','Moneda','VNPP','Estado'];
  dataSource :any; 
   DTOFiltrosDocNeg :FiltrosDocumentosNegociables = new FiltrosDocumentosNegociables();
  constructor( private negociablesService:DocumentoNegociableService,
               private riesgo: RiesgoService, 
               private empresasService: EmpresasService, 
               private cavaliService : CavaliService,
               private router:Router,
               private loginService:LoginService) {
    this.user = JSON.parse(sessionStorage.getItem('UserActive'));
    this.adjuntarPDF = false;
    this.selectArchivo = false;
    this.ObtenerEmpresasCombo();
   }
  ngOnInit() {
    
    let rutas = this.router.url.split("/",3);
    this.ruta = rutas[2];

    if (this.ruta == 'recibo'){ 
        this.tipoComprobante = 'R';
        this.DTOFiltrosDocNeg.Tipo_Comprobante = 'R';
        this.isRecibo = true;
        this.isLetra = false;
    }else if (this.ruta == 'factura'){
      this.isRecibo = false;
      this.isLetra = false;
      this.tipoComprobante = 'F';
      this.DTOFiltrosDocNeg.Tipo_Comprobante  = 'F';
    }
    else if  (this.ruta == 'letra'){
      this.isLetra = true;
      this.isRecibo = false;
      this.tipoComprobante = 'L';
      this.DTOFiltrosDocNeg.Tipo_Comprobante  = 'L';
    }
    //this.idEncrip=CryptoJS.MD5(this.user.id_user.toString().trim()).toString();  
    //this.idEncrip=Buffer.from(this.user.id_user.toString()).toString('base64');
    this.DTOFiltrosDocNeg.user_id=this.user.id_user;
    if(this.user.id_roles == this.ID_ROL_PRONTOPAGO){
      this.flagEspecial = true;
    }
    this.filtradoDocNegociables();
  }

  CerrarVenta(){
   
    this.selectArchivo = false;
   
 }

   CerrarVentaAdjunto(){
   
    this.adjuntarPDF = false;
    this.filtradoDocNegociables();
 
  }  

  abrirSelecTipoArchivo(fila : string , tipoEmision?: string){
    if (tipoEmision =='Electrónico'){
      
      this.tipoEmsion='E';
    }else{
      this.tipoEmsion='F'
    }
    this.selectArchivo = !this.selectArchivo;
    this.DNegociable = fila;
  }

  abrirAdjuntarPDF(data : any ){
    this.negociablesService.dataNegociable = data;
    this.adjuntarPDF = true;
 

  
  }

  darBajaDocumento(idComprobante){
    Swal.fire({
      title: '',
      text: '¿Estás seguro en dar de baja el documento?',
      type: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Si, dar de baja',
      cancelButtonText: 'No, cancelar',
      reverseButtons: true,
      heightAuto: false
    }).then((result) => {
      if (result.value) {
        this.formExtornar = new FormGroup({
          'idComprobante' : new FormControl(idComprobante),
          'Estado' : new FormControl('B'),
          'Baja_Usuario': new FormControl(this.user.Usuario)
        })  
        this.negociablesService.actualizarDocNegociable(this.formExtornar.getRawValue(),idComprobante)
        .subscribe(res => { 
          Swal.fire(
            '¡Documento dado de baja!',
            'El documento fue dado de baja exitosamente',
            'success'
          ).then(resp => {
            if (resp.value == true) {
              this.filtradoDocNegociables();
            }
          });
          
        },
        err => {
          Swal.fire({
            title: "Error",
            text: "No se pudo dar de baja el documento",
            type: "error",
            allowOutsideClick: false,
            heightAuto: false
          });
        }
        )
      }
    })
  }

  ExtornarDocumento(idComprobante){
    Swal.fire({
      title: '',
      text: '¿Estás seguro de extornar el documento?',
      type: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Si, extornar',
      cancelButtonText: 'No, cancelar',
      reverseButtons: true,
      heightAuto: false
    }).then((result) => {
      if (result.value) {
        this.formExtornar = new FormGroup({
          'idComprobante' : new FormControl(idComprobante),
          'Estado' : new FormControl('R',)
        })  
        this.negociablesService.actualizarDocNegociable(this.formExtornar.getRawValue(),idComprobante)
        .subscribe(res => { 
          Swal.fire({
            title: '¡Documento extornado!',
            text: 'El documento fue extornado exitosamente',
            type: 'success',
            heightAuto: false
          }).then(resp1 => {
            if (resp1.value == true) {
              this.filtradoDocNegociables();
            }
          });
          
        },
        err => {
          Swal.fire({
            title: "Error",
            text: "No se pudo extornar el documento",
            type: "error",
            allowOutsideClick: false,
            heightAuto: false
          });
        }
        )
      } 
    })

  }

  EditarDocumento(id : string , tipoEmision?: string){

    if(this.isRecibo){
      this.loginService.clickGuard = true;
      this.router.navigate(['/negociables/recibo/RH/editar/',id]);
    }
    else if(this.isLetra){
      this.loginService.clickGuard = true;
      this.router.navigate(['/negociables/letra/LC/editar/',id]);
    }
    else{
      if(tipoEmision == "Físico"){
        this.loginService.clickGuard = true;
        this.router.navigate(['/negociables/factura/FF/editar/',id]);
      }else{
        this.loginService.clickGuard = true;
        this.router.navigate(['/negociables/factura/FE/editar/',id]);
      }
    }
  }

  verDocumento(id : string , tipoEmision?: string){
    if(this.isRecibo){
      this.loginService.clickGuard = true;
      this.router.navigate(['/negociables/recibo/RH/ver/',id]);
    }
    else if(this.isLetra){
      this.loginService.clickGuard = true;
      this.router.navigate(['/negociables/letra/LC/ver/',id]);
    }
    else{
      if(tipoEmision == "Físico"){
        this.loginService.clickGuard = true;
        this.router.navigate(['/negociables/factura/FF/ver/',id]);
      }else{
        this.loginService.clickGuard = true;
        this.router.navigate(['/negociables/factura/FE/ver/',id]);
      }
    }
  }
  
  cargarListadoCompleto(){
    this.loading = true;

    this.negociablesService.obtenerDocNegociables()
    .pipe(finalize(() => { this.loading = false; }))
    .subscribe(
      res => {
        this.docNegociables = Array.isArray(res) ? res : [];
        this.negociablesService.dataNegociables = this.docNegociables;
        this.docNegociables = this.docNegociables.filter(elem => elem.Estado == "Registrado");
        this.dataSource = new MatTableDataSource(this.docNegociables);
        this.dataSource.sort = this.sort;
        this.dataSource.paginator = this.paginator;
      },
      () => {
        this.docNegociables = [];
        this.negociablesService.dataNegociables = [];
        this.dataSource = new MatTableDataSource([]);
        Swal.fire({
          title: "Error",
          text: "No se pudo cargar el listado de documentos negociables.",
          type: "error",
          allowOutsideClick: false,
          heightAuto: false
        });
      }
    );
  }

  alerta(){
    alert('asd');
  }
  
  filtradoDocNegociables(){
    this.loading = true;
  
    if (this.ruc.value == null){
      this.id = "";
      this.DTOFiltrosDocNeg.Id = "";
    }

    this.negociablesService.FiltrarDatosListadoDocNegociables(this.DTOFiltrosDocNeg)
    .pipe(finalize(() => { this.loading = false; }))
    .subscribe(
      resp => {
        this.docNegociables = Array.isArray(resp) ? resp : [];
        this.negociablesService.dataNegociables = this.docNegociables;
        this.dataSource = new MatTableDataSource(this.docNegociables);
        this.dataSource.sort = this.sort;
        this.dataSource.paginator = this.paginator;
        this.pageSizeOptions = [15,20,30,50,100,200];
      },
      err => {
        this.docNegociables = [];
        this.negociablesService.dataNegociables = [];
        this.dataSource = new MatTableDataSource([]);
        const mensaje = (err && err.error && err.error.error)
          ? err.error.error
          : "No se pudo cargar el listado de documentos negociables.";
        Swal.fire({
          title: "Error",
          text: mensaje,
          type: "error",
          allowOutsideClick: false,
          heightAuto: false
        });
      }
    );
  }

  ObtenerEmpresasCombo() {
    const raw = sessionStorage.getItem('lstProvCbo');
    try {
      this.proveedoresArr = raw ? JSON.parse(raw) : [];
    } catch {
      this.proveedoresArr = [];
    }
    if (!Array.isArray(this.proveedoresArr)) {
      this.proveedoresArr = [];
    }

    this.filteredProveeedor = this.ruc.valueChanges.pipe(
      startWith(""),
      map(state =>
        state ? this._filterProv(state) : this.proveedoresArr.slice()
      )
    );
  }

  private _filterProv(value: string): any[] {
    const filterValue = value.toString().toLowerCase();

    return this.proveedoresArr.filter(
      state => state.Razon_Social.toLowerCase().includes(filterValue) === true
    );
  }

  obtenerId(termino :string){
    this.id = termino
    this.DTOFiltrosDocNeg.Id = termino;
  }
  
  EnterobtenerRucRazSocialProv(termino :string = ''){
    
    if (termino != null && termino != ''){
     
      let termino1 = termino.toLowerCase();                   
  
      for( let p of this.proveedoresArr){
  
          let raz = p.Razon_Social.toLocaleLowerCase();
        if (raz.indexOf(termino1)  >= 0){
            this.id = p.idEmpresa;
            this.DTOFiltrosDocNeg.Id = p.idEmpresa;
          }
  
      }

    }

  }
  
  registrarCavali(idComprobante){
    Swal.fire({
      title: 'Factrack - Cavali',
      text: '¿Deseas enviar el documento Nro. '+ idComprobante+' al proceso de registro en la plataforma Cavali?',
      type: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      confirmButtonText: 'Sí',
      cancelButtonColor: '#d33',
      cancelButtonText: 'No',
      heightAuto: false
    }).then((result) => {
      if (result.value) {
        this.cavaliService.registrarCavali(idComprobante).subscribe( res => {
          let rpt = res['data'];
          this.showNotification('success','top','right','Documento Nro. '+ idComprobante + ' ' + rpt);
        }, err => {
          let error = "";
          if(err.status == "406"){
            error = err.error.data;
          } else {
            error = err.error.error;
          }      
          this.showNotification('danger','top','right','Error al intentar registrar documento en Cavali. \n' + error);
        });
        Swal.fire({
          title: 'Satisfactorio!',
          text: 'Documento Nro. '+ idComprobante+' ha sido enviado para su registrar en Cavali.',
          type: 'success',
          heightAuto: false
        })
      }
    })
  }

  showNotification(type,from,align,message){
    
    //const type = ['','info','success','warning','danger']; => tipo de notificacion
    //from = [Top,bottom,etc] => orientacion vertical
    //align = center, left, right => orientacion horizontal
  
    $.notify({
        icon: "notifications",
        message: message
    },{
        type: type,
        timer: 4000,
        placement: {
            from: from,
            align: align
        },
        template: '<div data-notify="container" class="col-xl-4 col-lg-4 col-11 col-sm-4 col-md-4 alert alert-{0} alert-with-icon" role="alert">' +
          '<button mat-button  type="button" aria-hidden="true" class="close mat-button" data-notify="dismiss">  <i class="material-icons">close</i></button>' +
          '<i class="material-icons" data-notify="icon">notifications</i> ' +
          '<span data-notify="title">{1}</span> ' +
          '<span data-notify="message">{2}</span>' +
          '<div class="progress" data-notify="progressbar">' +
            '<div class="progress-bar progress-bar-{0}" role="progressbar" aria-valuenow="0" aria-valuemin="0" aria-valuemax="100" style="width: 0%;"></div>' +
          '</div>' +
          '<a href="{3}" target="{4}" data-notify="url"></a>' +
        '</div>'
    });
  }

}
